<template>
	<div>
		<q-table
			:data="data"
			:columns="columns"
			:pagination.sync="server_pagination"
			@request="request"
			:loading="loading"
			row-key="id"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[0]"
			binary-state-sort
			class="q-mt-md"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<q-tr slot="body" slot-scope="props" :props="props">
				<q-td auto-width key="move" :props="props">
					<q-btn
						flat
						round
						color="primary"
						icon="far fa-arrow-up"
						@click="moveItem(props, 'up')"
						:disable="!manage_trails"
					/>
					<q-btn
						flat
						round
						color="negative"
						icon="far fa-arrow-down"
						@click="moveItem(props, 'down')"
						:disable="!manage_trails"
					/>
				</q-td>

				<q-td key="content_order" :props="props">
					{{ props.row.content_order }}
					<q-popup-edit v-model="props.row.content_order" @hide="reorderItems(props.row)">
						<q-input v-model="new_order" type="number" />
					</q-popup-edit>
				</q-td>

				<q-td key="type_slug" :props="props">
					<q-icon :name="getIconName(props.row.type_slug)" size="1.2rem" />
					{{ $t(getLabel(props.row.type_slug)) }}
				</q-td>

				<q-td key="content_title" :props="props">
					{{ props.row.content_title }}
				</q-td>

				<q-td key="availability_date" :props="props">
					<q-datetime
						v-model="props.row.availability_date"
						type="date"
						format="DD/MM/YYYY"
						@input="saveConfigure()"
						clearable
					/>
				</q-td>

				<q-td key="content_parent_id" :props="props">
					<q-select
						v-model="props.row.content_parent_id"
						:options="getOptions(props.row)"
						@input="saveConfigure()"
						clearable
						:disable="!manage_trails"
					/>
				</q-td>
			</q-tr>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_trails' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="negative"
					class="full-width"
					:label="$t('unpublish')"
					icon="far fa-ban"
					@click="unpublish()"
					:disable="disableButtons"
				>
					<q-tooltip v-if="disableButtons">
						{{ $t('no_content_on_the_trail') }}
					</q-tooltip>
				</q-btn>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="positive"
					class="full-width"
					:label="$t('publish')"
					icon="far fa-upload"
					@click="publish()"
					:disable="disableButtons"
				>
					<q-tooltip v-if="disableButtons">
						{{ $t('no_content_on_the_trail') }}
					</q-tooltip>
				</q-btn>
			</div>
		</div>
		<div class="row gutter-sm justify-end q-mt-sm">
			<!-- SYNC TRAILS - DISABLED UNTIL FURTHER NOTICE -->
			<!-- <div class="col-xs-12 col-sm-4">
				<q-btn
					flat
					color="info"
					class="full-width"
					:label="$t('synchronize_certificates')"
					icon="far fa-sync"
					@click="syncCertificates()"
					:disable="disableButtons || disable_sync_request"
				>
					<q-tooltip>
						{{
							disableButtons
								? $t('no_content_on_the_trail')
								: disable_sync_request
								? $t('user_certificates_sync_is_running')
								: $t('trails_synchronize_certificates_tooltip')
						}}
					</q-tooltip>
				</q-btn>
			</div> -->
			<div class="col-xs-12 col-sm-3">
				<q-btn
					color="info"
					class="full-width"
					:label="$t('duplicate_trail')"
					icon="far fa-copy"
					@click="show_confirm_duplicate = true"
					:disable="disableButtons"
				/>
			</div>
		</div>
		<q-dialog v-model="show_confirm_duplicate" @ok="duplicateTrail">
			<span slot="title">{{ $t('duplicate_trail') }}</span>

			<span slot="message">{{ $t('confirm_duplicate_the_trail_and_all_its_contents') }}</span>

			<template slot="buttons" slot-scope="props">
				<q-btn
					color="tertiary"
					:label="$t('cancel')"
					@click="show_confirm_duplicate = false"
				/>
				<q-btn color="positive" :label="$t('confirm')" @click="duplicateTrail()" />
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
	props: ['manage_trails'],

	data() {
		return {
			id_trail: '',
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 0,
				descending: false,
				sortBy: 'hierarchy_order',
			},
			data: [],
			columns: [
				{
					name: 'move',
					required: true,
					label: '',
					align: 'left',
					field: 'move',
					sortable: false,
				},
				{
					name: 'content_order',
					required: true,
					label: 'order',
					align: 'left',
					field: 'content_order',
					sortable: false,
				},
				{
					name: 'type_slug',
					required: true,
					label: 'type',
					align: 'left',
					field: 'type_slug',
					sortable: false,
				},
				{
					name: 'content_title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'content_title',
					sortable: false,
				},
				{
					name: 'availability_date',
					required: true,
					label: 'availability_date',
					align: 'left',
					field: 'availability_date',
					sortable: false,
				},
				{
					name: 'content_parent_id',
					required: true,
					label: 'prerequisite',
					align: 'left',
					field: 'content_parent_id',
					sortable: false,
				},
			],
			loading: false,
			parents: [],
			new_order: '',
			show_alert_change: false,
			training: [],
			show_confirm_duplicate: false,
			show_training_in_progress_helper: false,
			selected_client: {},
			disable_sync_request: false,
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			user_client_module_items: 'common/user_client_module_items',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		disableButtons() {
			if (this.manage_trails) {
				if (this.data.length == 0) return true
				else return false
			} else return true
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				search: this.filter,
				ordering: order_by,
			}

			this.$axios
				.get(
					`/admin_trails/trails/${this.id_trail}/hierarchy/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.populateList(response.data)
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		saveConfigure() {
			this.$q.loading.show()

			let data = {
				items: this.data.map((e) => ({
					...e,
					content_parent_id: this.getParentId(e.content_parent_id),
					content_parent_type: this.getParentSlug(e.content_parent_id),
					content_parent_title: this.getParentTitle(e.content_parent_id),
					availability_date: e.availability_date
						? date.formatDate(e.availability_date, 'YYYY-MM-DD')
						: null,
				})),
			}

			this.$axios
				.post(`/admin_trails/trails/${this.id_trail}/hierarchy/`, data, this.getHeader)
				.then((response) => {
					this.populateList(response.data)

					this.$q.notify({
						message: this.$t('configure_edit_success'),
						type: 'positive',
						icon: 'fal fa-save',
					})
				})
				.catch((e) => {
					console.log(e)
				})
		},

		populateList(data) {
			this.server_pagination.rowsNumber = data.length

			this.data = data.map((e) => ({
				...e,
				move: e.content_type + e.content_id,
				content_parent_id: e.content_parent_id
					? e.content_parent_type + e.content_parent_id
					: null,
				type_slug: this.getTypeSlug(e.content_type),
				availability_date: e.availability_date
					? moment(e.availability_date)
							.tz('Etc/GMT')
							.format('YYYY-MM-DDTHH:mm:ss.SSS')
					: null,
			}))

			this.parents = data.map((e) => ({
				...e,
				value: e.content_type + e.content_id,
				label: e.content_title,
				type_slug: e.content_type,
				id: e.content_id,
			}))

			this.$q.loading.hide()
		},

		publish() {
			this.$q.loading.show()

			let data = {}

			this.$axios
				.post(`/admin_trails/trails/${this.id_trail}/publish/`, data, this.getHeader)
				.then((response) => {
					this.$router.push({ name: 'admin_trails' })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		unpublish() {
			this.$q.loading.show()

			let data = {}

			this.$axios
				.post(`/admin_trails/trails/${this.id_trail}/unpublish/`, data, this.getHeader)
				.then((response) => {
					this.$router.push({ name: 'admin_trails' })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		moveItem(item, direction) {
			this.$q.loading.show()

			if (direction == 'up' && item.row.content_order > 1) item.row.content_order--
			else if (direction == 'down' && item.row.content_order < this.data.length)
				item.row.content_order++

			let obj = this.data.find((obj) => {
				return obj.move !== item.row.move && obj.content_order === item.row.content_order
			})

			if (obj) {
				if (direction == 'up') {
					obj.content_order++
				}
				if (direction == 'down') {
					obj.content_order--
				}
			}

			this.saveConfigure()
		},

		getIconName(slug) {
			switch (slug) {
				case 'library':
					return 'fal fa-books'
				case 'news':
					return 'fal fa-newspaper'
				case 'trainings':
					return 'fal fa-graduation-cap'
				case 'presential':
					return 'fal fa-users-class'
				case 'webcasts':
					return 'fal fa-broadcast-tower'
				case 'live_classes':
					return 'fal fa-chalkboard-teacher'
				case 'podcasts':
					return 'fal fa-podcast'
				default:
					return 'fal fa-user'
			}
		},

		getOptions(row) {
			let options = []
			let selected = []
			let quantity_selected = 0

			this.data.forEach((element) => {
				if (element.content_parent_id) {
					selected.push({
						id: element.content_parent_id,
						origin: element.move,
					})
					quantity_selected++
				}
			})

			this.parents.forEach((parent) => {
				let is_selected = selected.find((obj) => {
					return obj.origin === parent.value
				})

				if (row.content_parent_id || quantity_selected < this.data.length - 1) {
					if (row.move != parent.value) {
						if (!is_selected) {
							options.push({
								value: parent.value,
								label: parent.label,
								type_slug: parent.content_type,
							})
						} else if (is_selected.id != row.move) {
							options.push({
								value: parent.value,
								label: parent.label,
								type_slug: parent.content_type,
							})
						}
					}
				}
			})
			return options
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		getParentSlug(id) {
			let obj = this.parents.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.type_slug
			else return null
		},

		getParentId(id) {
			let obj = this.parents.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.id
			else return null
		},

		getParentTitle(id) {
			let obj = this.parents.find((obj) => {
				return obj.value === id
			})
			if (obj) return obj.content_title
			else return null
		},

		reorderItems(row) {
			this.$q.loading.show()

			if (this.new_order > 0 && this.new_order <= this.data.length) {
				if (row.content_order > this.new_order) {
					this.data.forEach((data) => {
						if (
							data.move != row.move &&
							data.content_order < row.content_order &&
							data.content_order >= this.new_order
						) {
							if (data.content_order + 1 <= this.data.length) data.content_order++
						}
					})
				} else if (row.content_order < this.new_order) {
					this.data.forEach((data) => {
						if (
							data.move != row.move &&
							data.content_order > row.content_order &&
							data.content_order <= this.new_order
						) {
							if (data.content_order - 1 > 0) data.content_order--
						}
					})
				}

				row.content_order = this.new_order
				this.saveConfigure()
			}
			this.new_order = ''
		},

		getTypeSlug(type) {
			switch (type) {
				case 'library_file_new':
					return 'library'
				case 'news':
					return 'news'
				case 'group_training':
					return 'trainings'
				case 'presential_event_catalog':
					return 'presential'
				case 'webcast':
					return 'webcasts'
				case 'live_class':
					return 'live_classes'
				case 'podcast':
					return 'podcasts'
				default:
					return ''
			}
		},

		getLabel(key) {
			return this.selected_client[`title_${key}`] &&
				this.selected_client[`title_${key}`] !== ''
				? this.selected_client[`title_${key}`]
				: `${key}`
		},

		duplicateTrail() {
			this.show_confirm_duplicate = false
			this.$q.loading.show()

			this.$axios
				.get(`/admin_trails/trails/${this.id_trail}/duplicate/`, this.getHeader)
				.then((response) => {
					this.$router.push({
						name: 'admin_trail',
						params: { id: response.data.trail_complete_duplicated_id },
					})

					this.$emit('duplicate')

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		// FUNCTION BELOW IS DISABLED UNTIL FURTHER NOTICE
		// syncCertificates() {
		// 	this.$q.loading.show()

		// 	this.$axios
		// 		.get(`/admin_trails/trails/${this.id_trail}/certificate/`, this.getHeader)
		// 		.then(() => {
		// 			this.$q.notify({
		// 				message: this.$t('user_certificates_sync_request_success'),
		// 				type: 'positive',
		// 				icon: 'fal fa-save',
		// 			})
		// 		})
		// 		.catch((e) => {
		// 			console.log(e)
		// 			this.$q.notify({
		// 				message:
		// 					e.response && e.response.status === 429
		// 						? this.$t('user_certificates_sync_is_running')
		// 						: this.$t('user_certificates_sync_request_error'),
		// 				type: 'negative',
		// 				icon: 'fal fa-times',
		// 			})
		// 		})
		// 		.finally(() => {
		// 			this.disable_sync_request = true
		// 			this.$q.loading.hide()
		// 		})
		// },
	},

	created() {
		this.id_trail = this.$route.params.id

		this.request({
			pagination: this.server_pagination,
		})

		this.selected_client = this.clients.find((obj) => {
			return obj.id === this.id_user_client_selected
		})
	},
}
</script>

<style lang="stylus" scoped></style>
